var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9996 20C74.5625 20.0012 74.1335 20.1174 73.7554 20.3368C73.3774 20.5562 73.0637 20.8711 72.8458 21.25H62.4996C62.2662 21.2487 62.0372 21.3128 61.8384 21.435C61.6396 21.5571 61.4789 21.7325 61.3746 21.9413L59.2271 26.25H47.4996V23.75H46.2496V22.0225L50.5583 19.875C50.7671 19.7707 50.9425 19.6101 51.0646 19.4112C51.1868 19.2124 51.2509 18.9834 51.2496 18.75V15.9038C51.7262 15.6286 52.0987 15.2039 52.3093 14.6954C52.5199 14.187 52.5568 13.6232 52.4144 13.0917C52.272 12.5601 51.9581 12.0903 51.5215 11.7553C51.0849 11.4203 50.5499 11.2387 49.9996 11.2387C49.4493 11.2387 48.9143 11.4203 48.4777 11.7553C48.0411 12.0903 47.7272 12.5601 47.5848 13.0917C47.4423 13.6232 47.4793 14.187 47.6899 14.6954C47.9005 15.2039 48.273 15.6286 48.7496 15.9038V17.9775L44.4408 20.1313C44.2331 20.2351 44.0583 20.3948 43.9362 20.5924C43.8141 20.79 43.7495 21.0177 43.7496 21.25V23.75H36.2496V15C36.2497 14.7677 36.1851 14.54 36.063 14.3424C35.9409 14.1448 35.7661 13.9851 35.5583 13.8813L31.2496 11.7275V7.15377C31.7262 6.8786 32.0987 6.45386 32.3093 5.94542C32.5199 5.43697 32.5568 4.87324 32.4144 4.34166C32.272 3.81008 31.9581 3.34035 31.5215 3.00533C31.0849 2.6703 30.5499 2.48871 29.9996 2.48871C29.4493 2.48871 28.9143 2.6703 28.4777 3.00533C28.0411 3.34035 27.7272 3.81008 27.5848 4.34166C27.4423 4.87324 27.4793 5.43697 27.6899 5.94542C27.9005 6.45386 28.273 6.8786 28.7496 7.15377V12.5C28.7495 12.7323 28.8141 12.96 28.9362 13.1576C29.0583 13.3553 29.2331 13.5149 29.4408 13.6188L33.7496 15.7725V23.75H32.4996V26.25H28.2721L26.1246 21.9413C26.0203 21.7325 25.8596 21.5571 25.6608 21.435C25.462 21.3128 25.2329 21.2487 24.9996 21.25H19.6533C19.3782 20.7734 18.9534 20.4009 18.445 20.1903C17.9365 19.9797 17.3728 19.9428 16.8412 20.0852C16.3097 20.2276 15.8399 20.5415 15.5049 20.9781C15.1699 21.4147 14.9883 21.9497 14.9883 22.5C14.9883 23.0504 15.1699 23.5853 15.5049 24.0219C15.8399 24.4585 16.3097 24.7724 16.8412 24.9148C17.3728 25.0573 17.9365 25.0203 18.445 24.8097C18.9534 24.5991 19.3782 24.2266 19.6533 23.75H24.2271L26.3808 28.0588C26.4847 28.2666 26.6444 28.4413 26.842 28.5634C27.0396 28.6855 27.2673 28.7501 27.4996 28.75H32.4996V35H19.9996C19.7673 34.9999 19.5396 35.0645 19.342 35.1866C19.1444 35.3087 18.9847 35.4835 18.8808 35.6913L16.7271 40H7.15335C6.87818 39.5234 6.45343 39.1509 5.94499 38.9403C5.43655 38.7297 4.87282 38.6928 4.34123 38.8352C3.80965 38.9776 3.33992 39.2915 3.0049 39.7281C2.66987 40.1647 2.48828 40.6997 2.48828 41.25C2.48828 41.8004 2.66987 42.3353 3.0049 42.7719C3.33992 43.2085 3.80965 43.5224 4.34123 43.6648C4.87282 43.8073 5.43655 43.7703 5.94499 43.5597C6.45343 43.3491 6.87818 42.9766 7.15335 42.5H17.4996C17.7319 42.5001 17.9596 42.4355 18.1572 42.3134C18.3548 42.1913 18.5145 42.0166 18.6183 41.8088L20.7721 37.5H32.4996V38.75H34.9446V33.75C34.9054 33.1085 34.998 32.4658 35.2165 31.8614C35.4351 31.257 35.775 30.7037 36.2154 30.2356C36.6558 29.7675 37.1873 29.3945 37.7773 29.1396C38.3673 28.8846 39.0031 28.7531 39.6458 28.7531C40.2885 28.7531 40.9244 28.8846 41.5144 29.1396C42.1043 29.3945 42.6359 29.7675 43.0763 30.2356C43.5167 30.7037 43.8566 31.257 44.0752 31.8614C44.2937 32.4658 44.3863 33.1085 44.3471 33.75V38.75H47.4996V37.5H51.7271L53.8808 41.8088C53.9847 42.0166 54.1444 42.1913 54.342 42.3134C54.5396 42.4355 54.7673 42.5001 54.9996 42.5H60.3458C60.621 42.9766 61.0458 43.3491 61.5542 43.5597C62.0626 43.7703 62.6264 43.8073 63.158 43.6648C63.6895 43.5224 64.1593 43.2085 64.4943 42.7719C64.8293 42.3353 65.0109 41.8004 65.0109 41.25C65.0109 40.6997 64.8293 40.1647 64.4943 39.7281C64.1593 39.2915 63.6895 38.9776 63.158 38.8352C62.6264 38.6928 62.0626 38.7297 61.5542 38.9403C61.0458 39.1509 60.621 39.5234 60.3458 40H55.7721L53.6246 35.6913C53.5203 35.4825 53.3596 35.3071 53.1608 35.185C52.962 35.0628 52.7329 34.9987 52.4996 35H47.4996V28.75H59.9996C60.2329 28.7513 60.462 28.6872 60.6608 28.5651C60.8596 28.4429 61.0203 28.2675 61.1246 28.0588L63.2721 23.75H72.8458C73.0655 24.1305 73.3816 24.4463 73.7621 24.6658C74.1427 24.8852 74.5744 25.0005 75.0137 25C75.4531 24.9995 75.8845 24.8832 76.2646 24.6629C76.6447 24.4426 76.96 24.126 77.1788 23.7451C77.3976 23.3641 77.5121 22.9322 77.5109 22.4929C77.5096 22.0536 77.3927 21.6224 77.1717 21.2427C76.9508 20.8629 76.6336 20.5482 76.2523 20.33C75.871 20.1119 75.4389 19.998 74.9996 20Z",
    fill: "url(#paint0_linear_311_1012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6491 31.25C39.0102 31.2747 38.4072 31.5518 37.9723 32.0204C37.5374 32.4891 37.3061 33.1111 37.3291 33.75V48.75L32.3891 45.1375C32.1405 44.9553 31.8567 44.8268 31.5559 44.76C31.255 44.6932 30.9435 44.6895 30.6412 44.7494C30.3389 44.8092 30.0523 44.9311 29.7995 45.1074C29.5467 45.2838 29.3333 45.5107 29.1728 45.7737C28.8572 46.2643 28.7117 46.845 28.7586 47.4265C28.8056 48.0079 29.0425 48.5577 29.4328 48.9913L33.8491 53.75V57.205C33.8425 57.6585 33.9581 58.1055 34.1838 58.4989C34.4094 58.8924 34.7368 59.2179 35.1316 59.4413L36.1691 60V66.25H50.0291V61.25L51.2503 57.5V47.5C51.2733 46.8611 51.042 46.2391 50.6071 45.7704C50.1722 45.3018 49.5692 45.0247 48.9303 45H41.9703V33.75C41.9933 33.1109 41.7618 32.4887 41.3266 32.02C40.8915 31.5513 40.2881 31.2744 39.6491 31.25Z",
    fill: "url(#paint1_linear_311_1012)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 68.75H33.75V77.5H51.25V68.75Z",
    fill: "url(#paint2_linear_311_1012)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8.75C60.6904 8.75 61.25 8.19036 61.25 7.5C61.25 6.80964 60.6904 6.25 60 6.25C59.3096 6.25 58.75 6.80964 58.75 7.5C58.75 8.19036 59.3096 8.75 60 8.75Z",
    fill: "url(#paint3_linear_311_1012)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 11.25C65.6904 11.25 66.25 10.6904 66.25 10C66.25 9.30964 65.6904 8.75 65 8.75C64.3096 8.75 63.75 9.30964 63.75 10C63.75 10.6904 64.3096 11.25 65 11.25Z",
    fill: "url(#paint4_linear_311_1012)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 16.25C68.1904 16.25 68.75 15.6904 68.75 15C68.75 14.3096 68.1904 13.75 67.5 13.75C66.8096 13.75 66.25 14.3096 66.25 15C66.25 15.6904 66.8096 16.25 67.5 16.25Z",
    fill: "url(#paint5_linear_311_1012)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 8.75C21.9404 8.75 22.5 8.19036 22.5 7.5C22.5 6.80964 21.9404 6.25 21.25 6.25C20.5596 6.25 20 6.80964 20 7.5C20 8.19036 20.5596 8.75 21.25 8.75Z",
    fill: "url(#paint6_linear_311_1012)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 11.25C16.9404 11.25 17.5 10.6904 17.5 10C17.5 9.30964 16.9404 8.75 16.25 8.75C15.5596 8.75 15 9.30964 15 10C15 10.6904 15.5596 11.25 16.25 11.25Z",
    fill: "url(#paint7_linear_311_1012)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.25C14.4404 16.25 15 15.6904 15 15C15 14.3096 14.4404 13.75 13.75 13.75C13.0596 13.75 12.5 14.3096 12.5 15C12.5 15.6904 13.0596 16.25 13.75 16.25Z",
    fill: "url(#paint8_linear_311_1012)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 58.75C23.1904 58.75 23.75 58.1904 23.75 57.5C23.75 56.8096 23.1904 56.25 22.5 56.25C21.8096 56.25 21.25 56.8096 21.25 57.5C21.25 58.1904 21.8096 58.75 22.5 58.75Z",
    fill: "url(#paint9_linear_311_1012)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 56.25C18.1904 56.25 18.75 55.6904 18.75 55C18.75 54.3096 18.1904 53.75 17.5 53.75C16.8096 53.75 16.25 54.3096 16.25 55C16.25 55.6904 16.8096 56.25 17.5 56.25Z",
    fill: "url(#paint10_linear_311_1012)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15 51.25C15.6904 51.25 16.25 50.6904 16.25 50C16.25 49.3096 15.6904 48.75 15 48.75C14.3096 48.75 13.75 49.3096 13.75 50C13.75 50.6904 14.3096 51.25 15 51.25Z",
    fill: "url(#paint11_linear_311_1012)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 58.75C63.1904 58.75 63.75 58.1904 63.75 57.5C63.75 56.8096 63.1904 56.25 62.5 56.25C61.8096 56.25 61.25 56.8096 61.25 57.5C61.25 58.1904 61.8096 58.75 62.5 58.75Z",
    fill: "url(#paint12_linear_311_1012)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 56.25C68.1904 56.25 68.75 55.6904 68.75 55C68.75 54.3096 68.1904 53.75 67.5 53.75C66.8096 53.75 66.25 54.3096 66.25 55C66.25 55.6904 66.8096 56.25 67.5 56.25Z",
    fill: "url(#paint13_linear_311_1012)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51.25C70.6904 51.25 71.25 50.6904 71.25 50C71.25 49.3096 70.6904 48.75 70 48.75C69.3096 48.75 68.75 49.3096 68.75 50C68.75 50.6904 69.3096 51.25 70 51.25Z",
    fill: "url(#paint14_linear_311_1012)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_1012",
    x1: 78.4831,
    y1: 3.11578,
    x2: 42.6539,
    y2: 66.4665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_311_1012",
    x1: 51.5435,
    y1: 31.7819,
    x2: 19.6621,
    y2: 51.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_311_1012",
    x1: 51.4768,
    y1: 68.883,
    x2: 44.2661,
    y2: 82.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_311_1012",
    x1: 61.2824,
    y1: 6.28799,
    x2: 58.7503,
    y2: 8.75031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_311_1012",
    x1: 66.2824,
    y1: 8.78799,
    x2: 63.7503,
    y2: 11.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_311_1012",
    x1: 68.7824,
    y1: 13.788,
    x2: 66.2503,
    y2: 16.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_311_1012",
    x1: 22.5324,
    y1: 6.28799,
    x2: 20.0003,
    y2: 8.75031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_311_1012",
    x1: 17.5324,
    y1: 8.78799,
    x2: 15.0003,
    y2: 11.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_311_1012",
    x1: 15.0324,
    y1: 13.788,
    x2: 12.5003,
    y2: 16.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_311_1012",
    x1: 23.7824,
    y1: 56.288,
    x2: 21.2503,
    y2: 58.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_311_1012",
    x1: 18.7824,
    y1: 53.788,
    x2: 16.2503,
    y2: 56.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_311_1012",
    x1: 16.2824,
    y1: 48.788,
    x2: 13.7503,
    y2: 51.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_311_1012",
    x1: 63.7824,
    y1: 56.288,
    x2: 61.2503,
    y2: 58.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_311_1012",
    x1: 68.7824,
    y1: 53.788,
    x2: 66.2503,
    y2: 56.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_311_1012",
    x1: 71.2824,
    y1: 48.788,
    x2: 68.7503,
    y2: 51.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.1b3e2d3c6c00bf194cf76f70a515ef29.svg";
export { ForwardRef as ReactComponent };